// Copyright (c) 2019 Deere & Company

import './index.scss';
import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import FindClaim from './components/find-claim';
import PropTypes from 'prop-types';

class ClaimPage extends Component {

    state= {
        navParameter: '',
    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'findClaim' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render () {

        return (
            <AuthenticatedPage className="claim-page">
                <FindClaim
                    reload={this.state.navParameter}
                    updateReload={this.updateReload}
                />
            </AuthenticatedPage>
        );

    }

}

ClaimPage.displayName = 'ClaimPage';
ClaimPage.propTypes = {
    location: PropTypes.object.isRequired,
};
export default ClaimPage;
